// This file was created using Claude AI on 2026-01-06
import * as Sentry from '@sentry/react';
import { EnumMessageLevel, type IApiMessage } from '@synqo/frontend-component-library';

export function getTraceIdsFromMessages(messages: IApiMessage[]): string[] {
    return messages.filter((msg) => msg.trace_id).map((msg) => msg.trace_id!);
}

export function getPrimaryTraceId(messages: IApiMessage[]): string | undefined {
    const errorMessage = messages.find(
        (msg) => msg.level === EnumMessageLevel.Danger || msg.level === EnumMessageLevel.Warning,
    );
    const primaryMsg = errorMessage ?? messages[0];
    return primaryMsg?.trace_id;
}

export function getSentryTraceId(): string | undefined {
    try {
        const client = Sentry.getClient();
        if (!client) {
            return undefined;
        }

        const span = Sentry.getActiveSpan();
        if (span) {
            return span.spanContext()?.traceId;
        }

        const scope = Sentry.getCurrentScope();
        const propagationContext = scope.getPropagationContext();
        return propagationContext?.traceId;
    } catch {
        return undefined;
    }
}
